<template lang="pug">
    feathers-vuex-find(service="users" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title
                | Select User
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
            v-data-table(
                :headers="userRolesHeaders"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.fullname="{ item }")
                    a(:href="`https://www.breakinghits.app/${item.url}`" style="color: #000;" target="__site__")
                        b {{ item.fname }} {{ item.lname }}
                    |  ({{ item.email }}) 
                    br
                    i(style="color: gray;") {{ item.url }}

                template(v-slot:item.action="{ item }")
                    v-btn.small(@click="selectUser(item)") Select
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import { numberToReadable, autoCompleteInstagramUrl } from '@/utils/helpers';

export default {
    data() {
        return {
            searchUser: '',
            modalPasswordShow: false,
            modalPasswordLoading: false,
            successMessage: false,
            userRolesHeaders: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Full Name',
                    align: 'start',
                    sortable: true,
                    value: 'fullname'
                },
                {
                    text: 'Action',
                    align: 'start',
                    sortable: false,
                    value: 'action'
                },
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['id'],
                sortDesc: [true]
            },
            query: { /*id: { $nin: [this.user.id] }*/
                status: { $nin: [-98, -99] }
             },
        };
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                if(isNaN(parseInt(this.searchUser))) {
                    return {
                        $or: [
                            { fname: { $like: `%${this.searchUser}%` } },
                            { lname: { $like: `%${this.searchUser}%` } },
                            { email: { $like: `%${this.searchUser}%` } },
                            { url: { $like: `%${this.searchUser}%` } }
                        ]
                    };
                } else {
                    return {
                        id: this.searchUser
                    };
                }
                
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                if(isNaN(parseInt(this.searchUser))) {
                    return {
                        $or: [
                            { fname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                            { lname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                            { email: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                            { url: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                        ]
                    };
                } else {
                    return {
                        id: parseInt(this.searchUser)
                    };
                }
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
        ...mapState('auth', ['user'])
    },
    watch: {
        searchUser(val) {
            this.dataQuery = {
                ...this.dataQuery,
                $or: [
                    { username: { $regex: val, $options: 'i' } },
                    { email: { $regex: val, $options: 'i' } },
                ],
            };
        },
    },
    methods: {
        selectUser(user) {
            this.$emit('select', user);
        },
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        ...mapActions({
            changePassword: 'user/changePassword',
            onActivateUser: 'user/activateUser',
            onError: 'notification/error',
        }),
    },
};
</script>